// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__PnQLs","container":"styles_container__2XiJS","title":"styles_title__3zuFa"};